/**
 * Stable event_id helper for Meta CAPI / browser pixel deduplication.
 *
 * The browser side (`fbq('track', name, params, { eventID })`) and the server
 * side (`ServerEvent.setEventId(...)`) must publish the same value to let Meta
 * dedup. This helper is the single source of truth for the formula, mirrored
 * on the server in `src/app/services/meta/meta-event-id.ts`. A parity test in
 * the server package keeps them byte-identical.
 *
 * Convention: `${eventName}_${entityId}`. Different event names get different
 * IDs even when fired for the same entity (e.g. a Purchase + Subscribe pair on
 * the same order), so each dedups independently.
 */
export function makeMetaEventId(eventName, entityId) {
    return `${eventName}_${entityId}`;
}
